import React from 'react';
import ReactTable from 'react-table'




class HourValuesPage extends React.Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    }
	    this.renderEditable = this.renderEditable.bind(this)
	}
	
	handleHourValueCellBlur = (cellInfo, event) => {
		const data = this.props.rows
		let value =  parseInt(event.target.value)
		isNaN(value) ? value = 0 : ''
		this.props.updateRowsInfo(cellInfo, value, this.props.type)
	}
	handleHourValueCellChange = (cellInfo, event) => {
		const data = this.props.rows
		let value =  parseInt(event.target.value)
		this.props.updateRowsInfo(cellInfo, value, this.props.type)
	}
	
	renderEditable(cellInfo) {
	    return (
	      <div>
	        <input 
	        	type="number"
	        	value={this.props.rows[cellInfo.index][cellInfo.column.id]}
				onBlur={(e) =>{this.handleHourValueCellBlur(cellInfo, e)}}
				onChange={(e) =>{this.handleHourValueCellChange(cellInfo, e)}}
	      		className="editable-cell"
	      	/>
	      </div>	
	    );
	 }

	render() {
		let data  = this.props.rows
		return (
			<div>
				<div className="flex">
					<h3>Valores Hora tipo {this.props.type}</h3>
				</div>
				<div className='proportions-container'>
			        <ReactTable
			          data={this.props.rows}
			          resizeable={true}
			          columns={[
			            {
			              Header: "Año de Ingreso",
			              accessor: "label",
			              maxWidth: 200,
			              className: 'proportion-cell'
			            },
			            {
			              Header: "Valor hora de Basica",
			              accessor: "middle",
			              maxWidth: 200,
			              className: 'proportion-cell',
			              Cell: this.renderEditable
			            },
			   			{
			              Header: "Valor hora de Media",
			              accessor: "high",
			              maxWidth: 200,
			              className: 'proportion-cell',
			              Cell: this.renderEditable
			            },
			          ]}
			          defaultPageSize={10}
			          className="-striped -highlight"
			        />

		      	</div>
		      	<div className='save-proportions-button-container'>
			      	<button className='btn btn-primary' onClick={() => this.props.updateMethod()}>Actualizar</button>
		      	</div>
		    </div>
      	)
	}

}

export default HourValuesPage


// WEBPACK FOOTER //
// ./src/components/hourValues/HourValuesPage.js